<template>
  <span
    class="match-result-tennis flex font-bold"
    v-if="resultPeriod.length">
    <span class="period-points color-important text-center">
      {{ gameScore }}
    </span>
    <span
      class="period color-faded text-center"
      :class="{ 'period-normal': isLessThen4 }"
      v-for="(period, index) in resultPeriod.slice(0, -1)"
      :key="index">
      <span
        class="flex-inline"
        v-if="isLessThen4">
        <span :class="{ 'color-normal': isHigher(period[0], period[1]) }">
          {{ period[0] }}
        </span>
        <span>:</span>
        <span :class="{ 'color-normal': isHigher(period[1], period[0]) }">
          {{ period[1] }}
        </span>
      </span>
      <span v-else>
        <span
          class="period-home flex-center"
          :class="{ 'color-normal': isHigher(period[0], period[1]) }">
          {{ period[0] }}
        </span>
        <span
          class="period-away flex-center"
          :class="{ 'color-normal': isHigher(period[1], period[0]) }">
          {{ period[1] }}
        </span>
      </span>
    </span>
    <span class="period-wide text-center">
      {{ resultPeriod[resultPeriod.length - 1][0] }}:{{ resultPeriod[resultPeriod.length - 1][1] }}
    </span>
  </span>
</template>

<script>
import { comparison } from '@/services/mixins';

export default {
  name: 'MatchResultsTennis',
  mixins: [comparison],
  props: {
    gameScore: {
      required: true,
      type: String,
      default: '',
    },
    resultPeriod: {
      required: true,
      type: Array,
    },
  },
  computed: {
    isLessThen4() {
      return this.resultPeriod.length <= 3;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-result-tennis {
  flex-direction: row;
  justify-content: flex-end;

  .period-wide {
    width: 40%;
  }

  .period {
    width: 15%;

    &.period-normal {
      width: 30%;
    }

    .period-home,
    .period-away {
      height: 50%;
      font-size: 0.625rem;
    }
  }

  .period-points {
    position: absolute;
    top: 0;
    right: -$match-points-width;
    bottom: 0;
    width: $match-points-width;
  }
}
</style>
